import {EntityService} from '../../../../service/EntityService';

export class TenantCompanyService extends EntityService {

  static entity = 'app/tenant-company';

}
